import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { RecoilRoot } from 'recoil';
import App from './client/Components/App';
import { getMessages, getLocale } from './client/i18n';

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
      <IntlProvider locale={getLocale()} messages={getMessages()}>
        <App />
      </IntlProvider>
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById('root')
);
